// Not abstract because TypeScript will complain we can't construct it when dealing with generics
export class BaseModel {}
